<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="header accent-700 p-24">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="contact-name mt-8">Motivo da exclusão</div>
            <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>  
            </button>
        </mat-toolbar-row>
    </mat-toolbar>


  <div mat-dialog-content class="p-12 pb-0 m-0">

    <form [formGroup]="exclusionMotiveForm" class="w-100-p">

      <mat-form-field class="w-100-p mr-12" appearance="outline">
        <mat-label>Motivo de Exclusão</mat-label>
        <input matInput [matAutocomplete]="autoInsuranceF" formControlName="exclusionMotive" autocomplete="off" required
          type="search"/>
        <button *ngIf="exclusionMotiveForm.controls['exclusionMotive'].value" matSuffix mat-icon-button
          aria-label="Clear" (click)="exclusionMotiveForm.controls['exclusionMotive'].setValue('')">
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete autoActiveFirstOption #autoInsuranceF="matAutocomplete" autoActiveFirstOption
          [displayWith]="displayFn">
          <mat-option *ngFor="let movite of exclusionMotive" [value]="movite">
            <p *ngIf="movite">
              {{ movite.name }}
            </p>
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="exclusionMotiveForm.get('exclusionMotive').hasError('required')">
          Campo é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100-p" appearance="outline">
        <mat-label>Anotação Complementar </mat-label>
        <input id=" register-operational-patient-person-name-edit-form_it" matInput maxlength="250"
          formControlName="note" name="name">
      </mat-form-field>


    </form>

  </div>

  <div mat-dialog-actions class=" m-0 p-16" fxLayout="row" fxLayoutAlign="end end">
    <button mat-raised-button (click)="dimiss()" class="mr-12">
      Cancelar
    </button>
    <button mat-raised-button (click)="confirm()" color="accent">
      Confirmar
    </button>
  </div>
</div>